// src/pages/KitBuilder.js
import { useEffect } from "react";

export default function KitBuilder() {
  useEffect(() => {
    // check if script already loaded
    if (!document.getElementById("kitbuilder-script")) {
      const script = document.createElement("script");
      script.id = "kitbuilder-script";
      script.src =
        "https://api.kitbuilder.co.uk/api/bootstrapper?distributorId=16692573&key=34a020fb5c69a2ca0dca5bdbd4724884";
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        if (window.KitBuilder) {
          window.KitBuilder.init("#kitBuilder");
        }
      };
    } else {
      // script already there, just init again
      if (window.KitBuilder) {
        window.KitBuilder.init("#kitBuilder");
      }
    }
  }, []);

  return (
    <>
      <div className="text-center text-[#ee403d] text-sm leading-relaxed mb-6 font-normal font-jost">
        <p className="mt-10 font-semi-bold">
          Note : All designs submitted/designed/emailed etc on this tool will
          remain property of TYKA. Please refer to Terms &amp; Conditions for
          any further information.
        </p>
        <p className="font-bold">Minimum Quantity 20 pcs per design.</p>
        <p className="font-semi-bold">
          Note: Due to different screen resolutions and device configurations,
          the colour shown on kit builder may vary after the sublimation
          process.
        </p>
        <p className="font-semi-bold">
          Delivery information for customised designs available only after final
          confirmation of designs from sales team.
        </p>
      </div>

      <div className="flex justify-center px-6 md:px-12">
        <div id="kitBuilder" className="w-full max-w-6xl">
          <noscript>Kit Builder requires JavaScript to be enabled</noscript>
        </div>
      </div>
    </>
  );
}
